import React from "react";
import { Router } from "react-router-dom";
import history from "./../services/history";
import CustomRoutes from "./../routes";
import { Provider } from "react-redux";
import configureStore from "../redux/store/index";
import "../static/css/wms.css";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "../query/queryClient";
import AppThemeProvider from "./AppThemeProvider";

export const store = configureStore();

function App() {
	return (
		<QueryClientProvider client={queryClient}>
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<Provider store={store}>
					<AppThemeProvider>
						<Router history={history}>
							<CustomRoutes />
						</Router>
					</AppThemeProvider>
				</Provider>
			</LocalizationProvider>
		</QueryClientProvider>
	);
}
export default App;
